  // (function(){
  //   const $locationBtns = document.querySelectorAll('.location-selector');
  //   const $btns = document.querySelectorAll('.widget-controller');
  //   const $widgets = document.querySelectorAll('.widget');

  //   function getUrlParameter(parameterName) {
  //       // Get the current URL
  //       const urlParams = new URLSearchParams(window.location.search);
        
  //       // Return the value of the specified parameter
  //       return urlParams.get(parameterName);
  //   }

    
  //   function handleClick(event) {
  //     event.preventDefault();
  //     const { controls, selection } = event.currentTarget.dataset
  //     localStorage.setItem('preferred-location', selection);
  //     const savedSelection = sessionStorage.getItem('preferred-location');

      
  //     $btns.forEach(($btn) => {
  //     const { controls, selection } = $btn.dataset
  //     console.log('Saved Selection Comparison:', {
  //       savedSelection,
  //       selection
  //     }, $btn)
  //       document.body.setAttribute('data-location', savedSelection);
        
  //       if(savedSelection === selection) {
  //         $btn.classList.add('active');
  //       } else {
  //         $btn.classList.remove('active');
  //       }
  //     })

  //     console.log('CLICKED WIDGETS:', $widgets);

  //     $widgets.forEach(($widget) => {
  //       if($widget.id === controls) {
  //         $widget.style.display = 'block';
  //       } else {
  //         $widget.style.display = 'none';
  //       }
  //     })
  //   }

  //   function handleLocationSelect(event) {
  //     const { selection } = event.currentTarget.dataset;
  //     const $btns = document.querySelectorAll(`.widget-controller[data-selection="${selection}"]`)

  //     sessionStorage.setItem('preferred-location', selection);
  //     document.body.setAttribute('data-location', selection);

  //     closeModal();
  //     Array.from($btns).forEach(($btn) => {
  //       $btn.click()
  //     })
  //   }

  //   function showModal() {
  //     document.querySelector('.fullscreen-location').classList.remove('closed');
  //   }

  //   function closeModal() {
  //     document.querySelector('.fullscreen-location').classList.add('closed');
  //   }

  //   function setSelectionsOnPage() {
  //     const savedSelection = sessionStorage.getItem('preferred-location');
  //     const urlSelection = getUrlParameter('location');
  //     const selection = urlSelection || savedSelection;


  //     if(urlSelection && !savedSelection) {
  //       sessionStorage.setItem('preferred-location', urlSelection);
  //     }

  //     console.log('Location Controller:', { urlSelection }, selection);
  //     if(!selection) return showModal();
  //     console.log('SetLocation:', document.body, selection)
  //     document.body.setAttribute('data-location', selection);
      
  //     const $btns = document.querySelectorAll(`.widget-controller[data-selection="${selection}"]`)
  //     Array.from($btns).forEach(($btn) => {
  //       const { action } = $btn.dataset;

  //       if(action && action == 'save') return;
  //       $btn.click()
  //     })      
  //   }
    
  //   Array.from($btns).forEach(($btn) => {
  //     $btn.addEventListener('click', handleClick)    
  //   })

  //   Array.from($locationBtns).forEach(($btn) => {
  //     $btn.addEventListener('click', handleLocationSelect)
  //   })

  //   setSelectionsOnPage();
  // })();

    (function(){
    const $locationBtns = document.querySelectorAll('.location-selector');
    const $btns = document.querySelectorAll('.widget-controller');
    const $widgets = document.querySelectorAll('.widget');
    const $locationContent = document.querySelectorAll('.location-content')

    function getUrlParameter(parameterName) {
        // Get the current URL
        const urlParams = new URLSearchParams(window.location.search);
        
        // Return the value of the specified parameter
        return urlParams.get(parameterName);
    }

    
    function handleClick(event) {
      event.preventDefault();
      const { controls, selection } = event.currentTarget.dataset
      localStorage.setItem('preferred-location', selection);
      const savedSelection = sessionStorage.getItem('preferred-location');

      
      $btns.forEach(($btn) => {
        const { controls, selection } = $btn.dataset;

        document.body.setAttribute('data-location', savedSelection);
        
        if(savedSelection === selection) {
          $btn.classList.add('active');
        } else {
          $btn.classList.remove('active');
        }
      })

      $widgets.forEach(($widget) => {
        if($widget.id === controls) {
          $widget.style.display = 'block';
        } else {
          $widget.style.display = 'none';
        }
      })

      console.log('toggleLocationContent:', selection, $locationContent);
      
      toggleLocationContent(selection);
    }

    function toggleLocationContent(locationToShow) {
      $locationContent.forEach(($el) => {
        if($el.dataset.location === locationToShow) {
          $el.style.display = '';
        } else {
          $el.style.display = 'none';
        }
      })
    }

    function handleLocationSelect(event) {
      const { selection } = event.currentTarget.dataset;
      const $btns = document.querySelectorAll(`.widget-controller[data-selection="${selection}"]`)

      sessionStorage.setItem('preferred-location', selection);
      document.body.setAttribute('data-location', selection);

      closeModal();
      Array.from($btns).forEach(($btn) => {
        $btn.click()
      })
    }

    function showModal() {
      document.querySelector('.fullscreen-location').classList.remove('closed');
    }

    function closeModal() {
      document.querySelector('.fullscreen-location').classList.add('closed');
    }

    function setSelectionsOnPage() {
      const savedSelection = sessionStorage.getItem('preferred-location');
      const urlSelection = getUrlParameter('location');
      const selection = urlSelection || savedSelection;


      if(urlSelection && !savedSelection) {
        sessionStorage.setItem('preferred-location', urlSelection);
      }

      console.log('Location Controller:', { urlSelection }, selection);
      if(!selection) return showModal();
      console.log('SetLocation:', document.body, selection)
      document.body.setAttribute('data-location', selection);
      
      const $btns = document.querySelectorAll(`.widget-controller[data-selection="${selection}"]`)
      Array.from($btns).forEach(($btn) => {
        const { action } = $btn.dataset;

        if(action && action == 'save') return;
        $btn.click()
      })      
    }
    
    Array.from($btns).forEach(($btn) => {
      $btn.addEventListener('click', handleClick)    
    })

    Array.from($locationBtns).forEach(($btn) => {
      $btn.addEventListener('click', handleLocationSelect)
    })

    setSelectionsOnPage();
  })();